<dashboardnav>
  
    <cradua-issuedcategory
        [issuedcategorys]="issuedcategorys$ | async"
        (issuedcategory)="onSubmitIssuedCategory($event)"
        (deleteIssuedCategoryEvent)="onDeleteIssuedCategory($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-issuedcategory>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  